/* eslint-disable camelcase */
export const self_reject = {
  'your-answer-has-been-received': 'Рақмет! Жауабыңыз жазылды',
  'do-you-want-reject-vacancy': 'Вакансиядан бас тартқыңыз келе ме?',
  'choose-reject-reason': 'Бас тарту себебін таңдаңыз',
  'reject-reason': 'Бас тарту себебі',
  'to-reject': 'Бас тарту',
};
